import NoiseCancellation from "./NoiseCancellation";

export default function Noise(props) {
  return (
    <div className="flex p-4">
      <NoiseCancellation {...props} />
    </div>
  );
}
